import { render } from "./ProviderAnalysisModule.vue?vue&type=template&id=37c11be7&ts=true"
import script from "./ProviderAnalysisModule.vue?vue&type=script&lang=ts"
export * from "./ProviderAnalysisModule.vue?vue&type=script&lang=ts"

import "./ProviderAnalysisModule.vue?vue&type=style&index=0&id=37c11be7&lang=scss"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__